module.exports = __webpack_public_path__ + "assets/d4114078346e748a240bdd4951e67910.png";